<template>
<div>
    <div id="mygalModal" aria-hidden="true" class="modal fade move-up in intro-modal modal-for-gal" style="display: block; z-index: 9999;">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="close-button" @click.prevent="CloseDialog($event)">×</div>
                <div class="new-modal">
                    <div class="modal_down bacground_sdo">
                        <div class="intro-modal-body">
                            <div class="trial-details">
                                <div class="preview" v-if="active_el==1">
                                    <div class="felix-form-block w-form">
                                        <a href="#" class="link-block-30 w-inline-block" @click.prevent="selectAnswer('id_image')">
                                            <div>
                                                <div class="text-block-545" style="color:black;">License or State ID</div>
                                            </div>
                                            <div>
                                                <div class="text-block-546">-></div>
                                            </div>
                                        </a>
                                        <a href="#" class="link-block-30 w-inline-block" @click.prevent="selectAnswer('full_body_image')">
                                            <div>
                                                <div class="text-block-545" style="color:black;">Full Body Image</div>
                                            </div>
                                            <div>
                                                <div class="text-block-546">-></div>
                                            </div>
                                        </a>
                                        <a href="#" class="link-block-30 w-inline-block" @click.prevent="selectAnswer('prescription_image')">
                                            <div>
                                                <div class="text-block-545" style="color:black;">Current Prescription</div>
                                            </div>
                                            <div>
                                                <div class="text-block-546">-></div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <div class="preview" v-if="active_el==2">
                                    <ImageUploader :idOfForm="id" :image-type="selectedOption" :question-id="id" @image-uploaded="handleImageUploaded" :key="imageKey"/>
                                </div>
                                <div class="footer-button" style="padding-top: 35px !important;" v-if="errorOccurred">
                                    <div class="w-form-fail" style="display:block">
                                        <div>{{errorMessage}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

    
<script>
import ImageUploader from "../common/ImageUploadS3.vue"
export default {
    props: ["id"],
    components: {
        ImageUploader
    },
    data() {
        return {
            baseUrl: `${process.env.VUE_APP_API_ENDPOINT}`,
            mykey: 1,
            message: '',
            active_el: 1,
            imageOptions: ['full_body_image', 'id_image', 'prescription_image'],
            selectedOption: '',
            errorMessage: '',
            errorOccurred: false,
            imageKey: 1
        }
    },
    mounted() {

    },
    methods: {
        async handleImageUploaded() {
            this.$emit("showSuccessUpload");
        },
        CloseDialog(event) {
            event.preventDefault();
            this.$emit("CloseBox");
        },
        selectAnswer(option) {
            this.selectedOption = option;
            this.active_el = 2;
        }
    },
    created() {

    }
}
</script>
    
    
<style scoped>
.modal {
    display: none;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.4);

}

.intro-modal-body {
    justify-content: center;
}

.intro-modal-heading {
    font-size: 18px;
    display: flex;
    justify-content: center;
}

.modal-content {
    position: relative;
    background-color: #fefefe;
    border-radius: 10px;
    max-width: 468px;
    margin: 15% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 80%;
}
.close-button {
    position: absolute;
    right: 20px;
    top: 10px;
    font-size: 24px;
    font-weight: bold;
    cursor: pointer;
    color: #888;
    transition: color 0.2s;
}

.close-button:hover {
    color: #000;
}
.dash-button {
    height: 45px;
}

.options-container {
    display: flex;
    flex-wrap: wrap;
}
</style>
